var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_scheme_types',
        })
      )?_c('div',{staticClass:"buttons"},[_c('WorkDocsSchemeTypeModal',{attrs:{"create":false,"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-scheme_type']['dialog_delete'][
            'udalit-tip-chertezha'
          ] +
          ' ' +
          _vm.item.name}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }